(() => {
  const setLoading = (form, isLoading) => {
    const button = form.querySelector('.newsletter-form__button');
    const spinner = button?.querySelector('.footer-newsletter__spinner');

    if (!button) return;

    button.classList.toggle('is-loading', isLoading);
    button.toggleAttribute('aria-busy', isLoading);
    spinner?.classList.toggle('hidden', !isLoading);
  };

  const initializeNewsletterForms = (root = document) => {
    root.querySelectorAll('.footer__newsletter').forEach((form) => {
      if (form.dataset.loadingStateBound === 'true') return;

      form.dataset.loadingStateBound = 'true';
      form.addEventListener('submit', () => {
        if (form.checkValidity()) setLoading(form, true);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeNewsletterForms());
  } else {
    initializeNewsletterForms();
  }

  document.addEventListener('shopify:section:load', (event) => initializeNewsletterForms(event.target));
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.footer__newsletter').forEach((form) => setLoading(form, false));
  });
})();
